import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue";
import { fetchLocale } from "@/composables/locale";
import type { MenuItemConfig } from "./types/menu";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const menuItems = ref<MenuItemConfig[]>([
  {
    icon: "home",
    name: "home",
    path: "/",
    label: "home",
  },
  {
    icon: "person-digging",
    name: "activity",
    label: "activity",
    isComposed: true,
    items: [
      {
        icon: "hammer",
        name: "coffrage",
        label: "coffrage",
        path: "/activity/coffrage",
      },
      {
        icon: "ring",
        name: "steel",
        label: "steel",
        path: "/activity/steel",
      },
      {
        icon: "stairs",
        name: "prefabricated",
        label: "prefabricated",
        path: "/activity/prefabricated",
      },
      {
        icon: "trowel",
        name: "mansory",
        label: "mansory",
        path: "/activity/mansory",
      },
    ],
  },
  {
    icon: "school-circle-check",
    name: "notableWorks",
    path: "/notableworks",
    label: "notableWorks",
  },
  {
    icon: "handshake",
    name: "affiliates",
    path: "/affiliates",
    label: "affiliates",
  },
]);

onMounted(async () => {
  await fetchLocale();
});

return (_ctx: any,_cache: any) => {
  const _component_MainMenu = _resolveComponent("MainMenu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainMenu, { items: menuItems.value }, null, 8, ["items"]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_AppFooter)
  ], 64))
}
}

})